/**
 * Options enum pour les listes déroulantes du formulaire d'expertise.
 * Miroir de backend/app/models/enums.py — mettre à jour les deux en synchronisation.
 *
 * Format : { value: <valeur Python enum>, label: <libellé français> }
 */

// ══════════════════════════════════════════════
//  CLIENT
// ══════════════════════════════════════════════

export const TYPE_CLIENT_OPTIONS = [
  { value: "particulier", label: "Particulier" },
  { value: "entreprise", label: "Entreprise" },
];

export const CIVILITE_OPTIONS = [
  { value: "M.", label: "M." },
  { value: "Mme", label: "Mme" },
  { value: "Société", label: "Société" },
];

export const FORME_JURIDIQUE_OPTIONS = [
  { value: "SCI", label: "SCI" },
  { value: "SAS", label: "SAS" },
  { value: "SASU", label: "SASU" },
  { value: "SARL", label: "SARL" },
  { value: "EURL", label: "EURL" },
  { value: "SA", label: "SA" },
  { value: "SNC", label: "SNC" },
  { value: "Autre", label: "Autre" },
];

// ══════════════════════════════════════════════
//  DOSSIER
// ══════════════════════════════════════════════

export const STATUT_DOSSIER_OPTIONS = [
  { value: "brouillon", label: "Brouillon" },
  { value: "en_cours", label: "En cours" },
  { value: "termine", label: "Terminé" },
  { value: "genere", label: "Généré" },
  { value: "envoye", label: "Envoyé" },
];

export const USAGE_RAPPORT_OPTIONS = [
  { value: "bancaire", label: "Bancaire" },
  { value: "successorale", label: "Successorale" },
  { value: "fiscale", label: "Fiscale" },
  { value: "patrimoniale", label: "Patrimoniale" },
  { value: "judiciaire", label: "Judiciaire" },
];

// ══════════════════════════════════════════════
//  EXPERTISE / MISSION
// ══════════════════════════════════════════════

export const CATEGORIE_EXPERTISE_OPTIONS = [
  { value: "propriete", label: "Propriété" },
  { value: "lot", label: "Lot" },
];

export const FORMAT_RAPPORT_OPTIONS = [
  { value: "standard", label: "Standard" },
  { value: "bcg", label: "BCG" },
];

export const TYPE_VALEUR_OPTIONS = [
  { value: "venale", label: "Vénale" },
  { value: "locative", label: "Locative" },
  { value: "venale_et_locative", label: "Vénale et locative" },
];

export const OCCUPATION_OPTIONS = [
  { value: "libre", label: "Libre" },
  { value: "occupee", label: "Occupée" },
  { value: "libre_et_occupee", label: "Libre et occupée" },
];

export const ETAT_BIEN_OPTIONS = [
  { value: "en_l_etat", label: "En l'état" },
  { value: "apres_travaux", label: "Après travaux" },
  { value: "etat_futur_achevement", label: "État futur d'achèvement" },
];

export const QUALITE_DONNEUR_ORDRE_OPTIONS = [
  { value: "creancier", label: "Créancier" },
  { value: "caution", label: "Caution" },
  { value: "proprietaire", label: "Propriétaire" },
  { value: "proprietaires_indivis", label: "Propriétaires indivis" },
  { value: "locataire", label: "Locataire" },
  { value: "locataires", label: "Locataires" },
  { value: "credit_preneur", label: "Crédit-preneur" },
  { value: "credit_bailleur", label: "Crédit-bailleur" },
  { value: "potentiel_acquereur", label: "Potentiel acquéreur" },
];

export const DESTINATION_BIEN_OPTIONS = [
  { value: "residentiel", label: "Résidentiel" },
  { value: "professionnel", label: "Professionnel" },
  { value: "mixte_residentiel_professionnel", label: "Mixte résidentiel / professionnel" },
  { value: "habitation", label: "Habitation" },
  { value: "mixte_habitation_commerce", label: "Mixte habitation / commerce" },
];

// ══════════════════════════════════════════════
//  PARCELLE
// ══════════════════════════════════════════════

export const TYPE_PROPRIETE_OPTIONS = [
  { value: "pleine_propriete", label: "Pleine propriété" },
  { value: "copropriete", label: "Copropriété" },
  { value: "indivision", label: "Indivision" },
  { value: "nue_propriete", label: "Nue-propriété" },
  { value: "demembrement", label: "Démembrement" },
  { value: "credit_bail", label: "Crédit-bail" },
];

export const FISCALITE_OPTIONS = [
  { value: "droits_enregistrement", label: "Droits d'enregistrement" },
  { value: "tva_marge", label: "TVA sur marge" },
  { value: "tva_immobiliere", label: "TVA immobilière" },
  { value: "hors_droits", label: "Hors droits" },
  { value: "ttc", label: "TTC" },
];

// ══════════════════════════════════════════════
//  SITUATION GÉNÉRALE (parcelle)
// ══════════════════════════════════════════════

export const GEODESIE_OPTIONS = [
  { value: "nord", label: "Nord" },
  { value: "nord_est", label: "Nord-est" },
  { value: "est", label: "Est" },
  { value: "sud_est", label: "Sud-est" },
  { value: "sud", label: "Sud" },
  { value: "sud_ouest", label: "Sud-ouest" },
  { value: "ouest", label: "Ouest" },
  { value: "nord_ouest", label: "Nord-ouest" },
  { value: "au_coeur", label: "Au cœur" },
];

export const TYPE_ENVIRONNEMENT_OPTIONS = [
  { value: "habitations_individuelles", label: "Habitations individuelles" },
  { value: "habitations_individuelles_et_collectifs", label: "Habitations individuelles et collectifs" },
  { value: "habitations_collectives", label: "Habitations collectives" },
  { value: "commerces", label: "Commerces" },
  { value: "mixte_commerces_habitations", label: "Mixte commerces / habitations" },
  { value: "zone_activite", label: "Zone d'activité" },
  { value: "rurale", label: "Rurale" },
];

export const QUALITE_ENVIRONNEMENT_OPTIONS = [
  { value: "peu_valorisant", label: "Peu valorisant" },
  { value: "moyennement_valorisant", label: "Moyennement valorisant" },
  { value: "valorisant", label: "Valorisant" },
  { value: "tres_valorisant", label: "Très valorisant" },
];

export const QUALITE_DESSERTE_OPTIONS = [
  { value: "difficile", label: "Difficile" },
  { value: "difficile_et_longue", label: "Difficile et longue" },
  { value: "aisee_mais_longue", label: "Aisée mais longue" },
  { value: "aisee_et_directe", label: "Aisée et directe" },
];

export const DESSERTE_TRANSPORTS_OPTIONS = [
  { value: "non_desservi", label: "Non desservi" },
  { value: "desservi", label: "Desservi" },
];

export const MODE_TRANSPORT_OPTIONS = [
  { value: "a_pied", label: "À pied" },
  { value: "en_voiture", label: "En voiture" },
  { value: "transports_en_commun", label: "Transports en commun" },
];

export const FAVORABILITE_OPTIONS = [
  { value: "non_favorable", label: "Non favorable" },
  { value: "peu_favorable", label: "Peu favorable" },
  { value: "moyennement_favorable", label: "Moyennement favorable" },
  { value: "favorable", label: "Favorable" },
  { value: "tres_favorable", label: "Très favorable" },
  { value: "exceptionnel_premium", label: "Exceptionnel / Premium" },
];

// ══════════════════════════════════════════════
//  APPRÉCIATIONS QUALITATIVES
// ══════════════════════════════════════════════

export const APPRECIATION_3_OPTIONS = [
  { value: "mediocre", label: "Médiocre" },
  { value: "moyenne", label: "Moyenne" },
  { value: "bonne", label: "Bonne" },
];

export const APPRECIATION_4_OPTIONS = [
  { value: "mauvaise", label: "Mauvaise" },
  { value: "moyenne", label: "Moyenne" },
  { value: "bonne", label: "Bonne" },
  { value: "tres_bonne", label: "Très bonne" },
];

export const APPRECIATION_5_OPTIONS = [
  { value: "mauvaise", label: "Mauvaise" },
  { value: "moyenne", label: "Moyenne" },
  { value: "courante", label: "Courante" },
  { value: "bonne", label: "Bonne" },
  { value: "tres_bonne", label: "Très bonne" },
];

// ══════════════════════════════════════════════
//  BIEN — TYPE, STANDING, ÉTAT
// ══════════════════════════════════════════════

export const TYPE_BIEN_OPTIONS = [
  { value: "maison", label: "Maison" },
  { value: "appartement", label: "Appartement" },
  { value: "chalet", label: "Chalet" },
  { value: "villa", label: "Villa" },
  { value: "maison_de_maitre", label: "Maison de maître" },
  { value: "propriete", label: "Propriété" },
  { value: "maison_de_village", label: "Maison de village" },
  { value: "ancien_corps_de_ferme", label: "Ancien corps de ferme" },
  { value: "appartement_duplex", label: "Appartement duplex" },
  { value: "appartement_triplex", label: "Appartement triplex" },
  { value: "local_commercial", label: "Local commercial" },
  { value: "terrain", label: "Terrain" },
  { value: "immeuble", label: "Immeuble" },
];

export const ARTICLE_GENRE_OPTIONS = [
  { value: "un", label: "Un" },
  { value: "une", label: "Une" },
];

export const SIS_SISE_OPTIONS = [
  { value: "sis", label: "Sis" },
  { value: "sise", label: "Sise" },
];

export const STANDING_OPTIONS = [
  { value: "modeste", label: "Modeste" },
  { value: "courant", label: "Courant" },
  { value: "bon_standing", label: "Bon standing" },
  { value: "tres_bon_standing", label: "Très bon standing" },
  { value: "luxe", label: "Luxe" },
];

export const ETAT_ENTRETIEN_VETUSTE_OPTIONS = [
  { value: "mauvais", label: "Mauvais" },
  { value: "moyen", label: "Moyen" },
  { value: "bon_etat_usage", label: "Bon état d'usage" },
  { value: "tres_bon_neuf", label: "Très bon / Neuf" },
];

// ══════════════════════════════════════════════
//  BIEN — TERRAIN
// ══════════════════════════════════════════════

export const TYPE_VOIE_ACCES_OPTIONS = [
  { value: "route_departementale", label: "Route départementale" },
  { value: "voie_communale", label: "Voie communale" },
  { value: "voie_privee", label: "Voie privée" },
  { value: "voie_privee_servitude", label: "Voie privée (servitude)" },
];

export const TYPE_PORTAIL_OPTIONS = [
  { value: "sans_portail", label: "Sans portail" },
  { value: "non_securise", label: "Non sécurisé" },
  { value: "portail_manuel", label: "Portail manuel" },
  { value: "portail_motorise", label: "Portail motorisé" },
];

export const FORME_TERRAIN_OPTIONS = [
  { value: "reguliere", label: "Régulière" },
  { value: "irreguliere", label: "Irrégulière" },
];

export const RELIEF_TERRAIN_OPTIONS = [
  { value: "plat", label: "Plat" },
  { value: "legerement_pentu", label: "Légèrement pentu" },
  { value: "pentu", label: "Pentu" },
  { value: "tres_pentu", label: "Très pentu" },
];

export const CLOTURE_OPTIONS = [
  { value: "non_clos", label: "Non clos" },
  { value: "partiellement_clos", label: "Partiellement clos" },
  { value: "entierement_clos", label: "Entièrement clos" },
];

export const QUALITE_ENTRETIEN_TERRAIN_OPTIONS = [
  { value: "non", label: "Non entretenu" },
  { value: "peu", label: "Peu entretenu" },
  { value: "correctement", label: "Correctement entretenu" },
  { value: "tres_bien", label: "Très bien entretenu" },
];

export const NIVEAU_ENCOMBREMENT_OPTIONS = [
  { value: "faible", label: "Faible" },
  { value: "normal", label: "Normal" },
  { value: "eleve", label: "Élevé" },
  { value: "total", label: "Total" },
];

export const PARTIE_NON_BATIE_OPTIONS = [
  { value: "terrasse_exterieure", label: "Terrasse extérieure" },
  { value: "jardin_agrement", label: "Jardin d'agrément" },
  { value: "cour", label: "Cour" },
  { value: "parc_paysage", label: "Parc paysagé" },
  { value: "parking_exterieur", label: "Parking extérieur" },
  { value: "parking_exterieur_couvert", label: "Parking extérieur couvert" },
];

// ══════════════════════════════════════════════
//  BIEN — BÂTI
// ══════════════════════════════════════════════

export const EPOQUE_CONSTRUCTION_OPTIONS = [
  { value: "avant_1850", label: "Avant 1850" },
  { value: "1850_1913", label: "1850 – 1913" },
  { value: "1914_1947", label: "1914 – 1947" },
  { value: "1948_1969", label: "1948 – 1969" },
  { value: "1970_1980", label: "1970 – 1980" },
  { value: "1981_1990", label: "1981 – 1990" },
  { value: "1991_2000", label: "1991 – 2000" },
  { value: "2001_2010", label: "2001 – 2010" },
  { value: "2011_2020", label: "2011 – 2020" },
  { value: "2021_plus", label: "2021 et après" },
];

export const TYPE_VITRAGE_OPTIONS = [
  { value: "simple", label: "Simple vitrage" },
  { value: "double", label: "Double vitrage" },
  { value: "triple", label: "Triple vitrage" },
];

export const QUALITE_DISTRIBUTION_OPTIONS = [
  { value: "defavorable", label: "Défavorable" },
  { value: "discutable", label: "Discutable" },
  { value: "rationnelle", label: "Rationnelle" },
];

export const APPRECIATION_ECLAIRAGE_OPTIONS = [
  { value: "mediocre", label: "Médiocre" },
  { value: "moyenne", label: "Moyenne" },
  { value: "bonne_recevable", label: "Bonne / Recevable" },
];

// ══════════════════════════════════════════════
//  BIEN — PRESTATIONS
// ══════════════════════════════════════════════

export const QUALITE_PRESTATIONS_OPTIONS = [
  { value: "mauvaise_a_renover", label: "Mauvaise / À rénover" },
  { value: "moyenne", label: "Moyenne" },
  { value: "bonne", label: "Bonne" },
  { value: "tres_bonne", label: "Très bonne" },
];

// ══════════════════════════════════════════════
//  BIEN — ÉQUIPEMENTS
// ══════════════════════════════════════════════

export const RESEAU_OPTIONS = [
  { value: "eau", label: "Eau" },
  { value: "electricite", label: "Électricité" },
  { value: "telephone", label: "Téléphone" },
  { value: "gaz_ville", label: "Gaz de ville" },
];

export const ASSAINISSEMENT_OPTIONS = [
  { value: "tout_a_egout", label: "Tout-à-l'égout" },
  { value: "fosse_septique", label: "Fosse septique" },
];

export const EQUIPEMENT_CONFORT_OPTIONS = [
  { value: "cheminee_foyer_ouvert", label: "Cheminée foyer ouvert" },
  { value: "cheminee_insert", label: "Cheminée insert" },
  { value: "poele_bois", label: "Poêle à bois" },
  { value: "poele_granules", label: "Poêle à granulés" },
  { value: "cuisine_simple", label: "Cuisine simple" },
  { value: "cuisine_amenagee", label: "Cuisine aménagée" },
  { value: "cuisine_tout_equipee", label: "Cuisine tout équipée" },
  { value: "cuisine_tout_equipee_haut_gamme", label: "Cuisine tout équipée haut de gamme" },
  { value: "alarme", label: "Alarme" },
  { value: "vmc_simple_flux", label: "VMC simple flux" },
  { value: "vmc_double_flux", label: "VMC double flux" },
  { value: "ventilation_naturelle", label: "Ventilation naturelle" },
  { value: "piscine_interieure", label: "Piscine intérieure" },
  { value: "piscine_exterieure_non_couverte", label: "Piscine extérieure non couverte" },
  { value: "piscine_exterieure_couverte", label: "Piscine extérieure couverte" },
  { value: "piscine_exterieure_non_couverte_chauffee", label: "Piscine extérieure non couverte chauffée" },
  { value: "piscine_exterieure_couverte_chauffee", label: "Piscine extérieure couverte chauffée" },
  { value: "sauna", label: "Sauna" },
  { value: "jacuzzi", label: "Jacuzzi" },
  { value: "veranda", label: "Véranda" },
  { value: "cave", label: "Cave" },
  { value: "garage", label: "Garage" },
];

export const SOURCE_SURFACES_OPTIONS = [
  { value: "certificat_loi_carrez", label: "Certificat Loi Carrez" },
  { value: "plans_permis_construire", label: "Plans permis de construire" },
  { value: "plan_cadastral", label: "Plan cadastral" },
  { value: "declaration_fiscale_h1", label: "Déclaration fiscale H1" },
  { value: "declarations_syndic", label: "Déclarations du syndic" },
  { value: "plans_etat_descriptif_division", label: "Plans état descriptif de division" },
  { value: "mesurage_telemetre", label: "Mesurage au télémètre" },
];

// ══════════════════════════════════════════════
//  BIEN — URBANISME & RISQUES
// ══════════════════════════════════════════════

export const TYPE_DPU_OPTIONS = [
  { value: "simple", label: "Simple" },
  { value: "renforce", label: "Renforcé" },
];

export const ZONAGE_PPR_OPTIONS = [
  { value: "blanche", label: "Blanche" },
  { value: "bleu_clair", label: "Bleu clair" },
  { value: "bleu_fonce", label: "Bleu foncé" },
  { value: "rouge", label: "Rouge" },
];

export const ZONE_SISMICITE_OPTIONS = [
  { value: "1_tres_faible", label: "1 — Très faible" },
  { value: "2_faible", label: "2 — Faible" },
  { value: "3_moderee", label: "3 — Modérée" },
  { value: "4_moyenne", label: "4 — Moyenne" },
  { value: "5_forte", label: "5 — Forte" },
];

export const RISQUES_INTERIEURS_OPTIONS = [
  { value: "non_constate", label: "Non constaté" },
  { value: "non", label: "Non" },
  { value: "oui", label: "Oui" },
];

// ══════════════════════════════════════════════
//  BCG SPÉCIFIQUE
// ══════════════════════════════════════════════

export const APPRECIATION_BCG_OPTIONS = [
  { value: "defavorable", label: "Défavorable" },
  { value: "mediocre", label: "Médiocre" },
  { value: "moyenne", label: "Moyenne" },
  { value: "bonne", label: "Bonne" },
];

export const LIQUIDITE_BIEN_OPTIONS = [
  { value: "mauvaise", label: "Mauvaise" },
  { value: "mediocre", label: "Médiocre" },
  { value: "moyenne", label: "Moyenne" },
  { value: "bonne", label: "Bonne" },
];

export const CATEGORIE_BIEN_OPTIONS = [
  { value: "bien_courant", label: "Bien courant" },
  { value: "bien_de_luxe", label: "Bien de luxe" },
  { value: "bien_d_amateur", label: "Bien d'amateur" },
  { value: "appartement_courant", label: "Appartement courant" },
  { value: "appartement_de_luxe", label: "Appartement de luxe" },
  { value: "appartement_d_amateur", label: "Appartement d'amateur" },
];

// ══════════════════════════════════════════════
//  ÉTUDE DE MARCHÉ
// ══════════════════════════════════════════════

export const ETAT_MARCHE_OPTIONS = [
  { value: "mauvais", label: "Mauvais" },
  { value: "moyen", label: "Moyen" },
  { value: "bon", label: "Bon" },
  { value: "tres_bon", label: "Très bon" },
];

export const EVOLUTION_PRIX_OPTIONS = [
  { value: "a_la_baisse", label: "À la baisse" },
  { value: "stable", label: "Stable" },
  { value: "a_la_hausse", label: "À la hausse" },
];

export const SOURCE_TRANSACTION_OPTIONS = [
  { value: "perval", label: "Perval" },
  { value: "dvf", label: "DVF" },
  { value: "patrim", label: "Patrim" },
  { value: "brokers", label: "Brokers" },
  { value: "carteron", label: "Carteron" },
];

export const TYPE_TRANSACTION_OPTIONS = [
  { value: "vente", label: "Vente" },
  { value: "offre", label: "Offre" },
];

export const SELECTION_QUARTILE_OPTIONS = [
  { value: "quartile_1", label: "Quartile 1 (bas)" },
  { value: "quartile_2", label: "Quartile 2 (médian)" },
  { value: "quartile_3", label: "Quartile 3 (haut)" },
];

// ══════════════════════════════════════════════
//  VALORISATION
// ══════════════════════════════════════════════

export const METHODE_VALORISATION_OPTIONS = [
  { value: "comparaison", label: "Par comparaison" },
  { value: "capitalisation", label: "Par capitalisation" },
  { value: "sol_construction", label: "Sol + Construction" },
  { value: "mixte", label: "Mixte" },
];

export const NATURE_AJUSTEMENT_OPTIONS = [
  { value: "situation", label: "Situation" },
  { value: "etat", label: "État" },
  { value: "prestations", label: "Prestations" },
  { value: "surface", label: "Surface" },
  { value: "environnement", label: "Environnement" },
  { value: "travaux", label: "Travaux" },
  { value: "marche", label: "Marché" },
  { value: "autre", label: "Autre" },
];

export const SENS_AJUSTEMENT_OPTIONS = [
  { value: "positif", label: "Positif (+)" },
  { value: "negatif", label: "Négatif (−)" },
];

export const TYPE_AJUSTEMENT_OPTIONS = [
  { value: "pourcentage", label: "Pourcentage (%)" },
  { value: "montant", label: "Montant (€)" },
];

export const LIQUIDITE_VALORISATION_OPTIONS = [
  { value: "liquide", label: "Liquide" },
  { value: "moyen", label: "Moyen" },
  { value: "mediocre", label: "Médiocre" },
  { value: "atypique", label: "Atypique" },
  { value: "exception", label: "Exception" },
];

export const DELAI_COMMERCIALISATION_OPTIONS = [
  { value: "normal", label: "Normal" },
  { value: "long", label: "Long" },
  { value: "tres_long", label: "Très long" },
];

export const REGIME_FISCAL_OPTIONS = [
  { value: "hd", label: "H.D." },
  { value: "ht", label: "H.T." },
  { value: "ttc", label: "TTC" },
  { value: "hc", label: "H.C." },
  { value: "ht_hc", label: "H.T. / H.C." },
];

export const DOSSIER_TRANSITIONS = {
  brouillon: [{ value: 'en_cours', label: 'Démarrer', variant: 'primary' }],
  en_cours: [{ value: 'termine', label: 'Terminer', variant: 'primary' }],
  termine: [
    { value: 'genere', label: 'Marquer généré', variant: 'primary' },
    { value: 'en_cours', label: 'Réouvrir', variant: 'secondary' },
  ],
  genere: [
    { value: 'envoye', label: 'Marquer envoyé', variant: 'primary' },
    { value: 'termine', label: 'Retour terminé', variant: 'secondary' },
  ],
  envoye: [],
};
